// Configuration globale pour filtrer les erreurs indésirables dans la console

// Liste des URLs qui peuvent générer des erreurs de connexion acceptables
const IGNORED_ERROR_URLS = [
  'calapi.inadiutorium.cz',
  'api.aelf.org'
];

// Fonction pour masquer les erreurs réseau spécifiques
export const setupErrorFiltering = () => {
  // Sauvegarder la fonction console.error originale
  const originalConsoleError = console.error;
  
  // Remplacer console.error pour filtrer les erreurs indésirables
  console.error = (...args) => {
    const errorMessage = args.join(' ');
    
    // Vérifier si l'erreur concerne une des URLs à ignorer
    const shouldIgnore = IGNORED_ERROR_URLS.some(url => 
      errorMessage.includes(url) && (
        errorMessage.includes('ERR_CONNECTION_REFUSED') ||
        errorMessage.includes('Failed to load resource') ||
        errorMessage.includes('Network Error') ||
        errorMessage.includes('net::ERR_')
      )
    );
    
    // Si l'erreur doit être ignorée, ne pas l'afficher
    if (shouldIgnore) {
      console.debug('Erreur réseau filtrée:', errorMessage);
      return;
    }
    
    // Sinon, afficher l'erreur normalement
    originalConsoleError.apply(console, args);
  };
};

// Fonction pour restaurer le comportement original de console.error
export const resetErrorFiltering = () => {
  // Cette fonction peut être appelée si nécessaire pour déboguer
  console.error = console.error.originalFunction || console.error;
};